import React, { useEffect, useState } from 'react';
import {
  StyledDocuments,
  StyledDocumentsList,
  StyledDocumentsItem,
  StyledDocumentsDownload,
  IconDocuments,
  StyledDocumentsName,
  StyledBoxInside,
  StyledTitleWidget
} from './style';
import { Folder, DirectorioBlanco } from '../../../../assets/images';
import Breadcrumb from '../../core/Breadcrumb';

import { getDepartmentDocsParents } from '../../../utils/apiDepartment';

const MenuDocs = props => {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    getDepartmentDocsParents().then(data => setFiles(data));
  }, []);
  const navigate = (name, fId, aId) => {
    const parseName = name.toLowerCase().replaceAll(' ', '-');
    props.history.push(
      `${props.history.location.pathname}/${parseName}?folderId=${fId}&associationId=${aId}`
    );
  };

  return (
    <StyledBoxInside>
      <StyledTitleWidget
        title="Documentos Intranet"
        type="ranking"
        icon={DirectorioBlanco}
        small
      />

      <StyledDocuments>
        <Breadcrumb
          dataList={[{ id: 0, txt: 'Documentos Intranet' }]}
          onClick={() => {}}
        />
        <StyledDocumentsList>
          {files &&
            files.map(doc => (
              <StyledDocumentsItem key={doc.folderId}>
                <StyledDocumentsDownload
                  onClick={() =>
                    navigate(doc.folderName, doc.folderId, doc.associationId)
                  }
                >
                  <IconDocuments svg={Folder} />
                  <StyledDocumentsName>
                    {doc.folderName[0].toUpperCase()}
                    {doc.folderName
                      .slice(1, doc.folderName.length)
                      .toLowerCase()}
                  </StyledDocumentsName>
                </StyledDocumentsDownload>
              </StyledDocumentsItem>
            ))}
        </StyledDocumentsList>
      </StyledDocuments>
    </StyledBoxInside>
  );
};

export default MenuDocs;
